import { analytics_methods } from "../../utils/analytics_methods";
import addKeysToSchema from "./schema";

function depurateExtrasData(extra, personIdObject) {

    const depuratedData = [];

    extra.forEach(item => {
        const depuratedValues = {};

        item.value.forEach(entry => {
            const { id, cost, currency, label, quantity } = entry;

            if (!depuratedValues[label]) {
                depuratedValues[label] = {
                    id,
                    cost,
                    currency,
                    label,
                    quantity: 0
                };
            }

            depuratedValues[label].quantity += quantity;
        });

        Object.values(depuratedValues).forEach(entry => {

            depuratedData.push({
                id: entry.id,
                cost: entry.cost,
                currency: entry.currency,
                label: entry.label,
                quantity: entry.quantity,
                person: personIdObject[item.id] ? personIdObject[item.id] : null
            })

        });
    });

    return depuratedData;
}


function pushTicketData(ticketName, ticketPrice, ticketQuantity, person) {
    const ticketData = {
        item_id: window?.analytics_buendia?.activity_id || null,
        item_name: window?.analytics_buendia?.activity_name || null,
        item_brand: window?.analytics_buendia?.item_brand || "",
        item_category: window?.analytics_buendia?.item_category || null,
        item_category2: window?.analytics_buendia?.item_category2 || null,
        origin: window?.analytics_buendia?.origin || null,
        time_selected: window?.analytics_buendia?.time_selected || null,
        date_selected: window?.analytics_buendia?.date_selected || null,
        ticket_category: ticketName || null,
        price: ticketPrice ?? null,
        quantity: ticketQuantity ?? null,
    };

    if (person) ticketData.person = person;

    window?.analytics_buendia?.items.push(ticketData);
}


function triggerEvent () {

    const personTickets = window?.analytics_buendia?.selected_tickets ?? {};
    const generalExtras = window?.analytics_buendia?.selected_tickets_extra ?? {};
    const personRelatedExtras = window?.analytics_buendia?.selected_tickets_extra_ticket ?? {};
    const personRelatedExtrasArray = [];
    let currency = undefined;
    let totalPrice = 0;
    let personId = {}

    // Person tickets

    for (const id in personTickets) {

        const ticket = personTickets[id];
        const isAdult = isAdultTicket(ticket?.label);
        const priceWithCommission = calculatePrice(ticket?.cost, isAdult);
        currency = ticket?.currency;
        totalPrice += ticket?.quantity * priceWithCommission;
        personId[id] = ticket?.label;

        pushTicketData(ticket?.label, priceWithCommission, ticket?.quantity);
    }

    // General extras tickets

    for (const id in generalExtras) { 

        const extra = generalExtras[id];
        const isAdult = isAdultTicket(extra?.label);
        const priceWithCommission = calculatePrice(extra?.cost, isAdult);
        totalPrice += extra?.quantity * priceWithCommission;

        pushTicketData(extra?.label, priceWithCommission, extra?.quantity);
    }


    // Person specific extras tickets

    for (const id in personRelatedExtras) { 

        personRelatedExtrasArray.push({
            id: id, 
            value: personRelatedExtras[id]
        })

    }

    const personRelatedExtrasData = depurateExtrasData(personRelatedExtrasArray, personId);

    personRelatedExtrasData.forEach(extra => {

        const isAdult = isAdultTicket(extra?.label);
        const priceWithCommission = calculatePrice(extra?.cost, isAdult);
        totalPrice += extra?.quantity * priceWithCommission;

        pushTicketData(extra?.label, priceWithCommission, extra?.quantity, extra?.person);

    });
    
    // Event schema and data

    const schema = addKeysToSchema({
        time_selected: "string",
        date_selected: "string",
        ticket_category: "string",
    });

    const data = {
        event: "add_to_cart",
        event_type: "cta_click",
        ecommerce: {
            currency: currency || null,
            value: window?.analytics_buendia?.total_price_with_extras ? analytics_methods.calculatePrice(window?.analytics_buendia?.total_price_with_extras, true) : totalPrice,
            items: window?.analytics_buendia?.items
        }
    }

    analytics_methods.sendToDataLayer(data, schema);

} 


export const add_to_cart_event = {
    triggerEvent
}


